import React from "react";
import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import HeadlessButton from "./Button";

/**
 * @param {object} props
 * @param {any} props.title
 * @param {any} props.description
 * @param {string} [props.buttonText]
 * @param {any} props.isOpen
 * @param {Function} [props.onClose]
 * @param {any} props.setIsOpen
 * @param {any} props.children
 * @param {React.ReactNode} [props.icon]
 * @param {string} [props.size]
 */
export default function HeadlessDialog({
  title,
  description,
  buttonText = "Close",
  isOpen,
  onClose = () => {},
  setIsOpen,
  children,
  icon,
  //  size="tw-w-[90vw]"
  size = "",
  ...restProps
}) {
  return (
    <>
      <Dialog
        className="tw-relative tw-z-10 tw-focus:outline-none"
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          onClose && onClose();
        }}
        {...restProps}
      >
        <DialogBackdrop className="tw-fixed tw-inset-0 tw-bg-bg-light/90" />
        <div className="tw-fixed tw-inset-0 tw-flex tw-w-screen tw-items-center tw-justify-center tw-p-4">
          <DialogPanel
            transition
            className={`tw-w-full tw-shadow-lg tw-max-w-md tw-rounded-xl tw-border tw-border-boarder-light tw-bg-white/5 tw-p-6 tw-backdrop-blur-2xl tw-duration-300 tw-ease-out tw-max-h-[90vh] tw-overflow-y-auto data-[closed]:tw-transform-[scale(95%)] data-[closed]:tw-opacity-0 ${size}`}
          >
            <div className="tw-grid tw-w-full tw-items-center tw-gap-y-4">
              <DialogTitle className="tw-flex tw-items-center tw-gap-2 tw-text-lg tw-font-semibold tw-text-text-primary-light">
                {icon && <span>{icon}</span>}
                <span>{title}</span>
              </DialogTitle>
              <Description>{description}</Description>
              {children}
              <HeadlessButton
                className="md:tw-w-[20%]"
                onClick={() => {
                  setIsOpen(false);
                  onClose && onClose();
                }}
              >
                {buttonText}
              </HeadlessButton>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}
